import { useTranslation } from 'react-i18next'
import { Box, Sx } from '@dhl/theme'

type Props = {
  tagType: string
}

const classes: Record<string, Sx> = {
  tag: {
    fontSize: '0.8rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    padding: '3px 5px 2px 5px',
    borderRadius: 2,
  },
  NEW: (theme) => ({
    color: theme.palette.grey[200],
    backgroundColor: theme.palette.primary.main,
  }),
  IMPROVEMENT: (theme) => ({
    color: theme.palette.common.black,
    backgroundColor: theme.palette.grey[300],
  }),
}

export const Tag = ({ tagType }: Props) => {
  const { t } = useTranslation()
  const tag = tagType || 'new'

  return <Box sx={[classes.tag, classes[tag.toUpperCase()]] as Sx}>{t(`widgets.whatsnew.tag.${tag}`)}</Box>
}
